module.exports = __webpack_public_path__ + "img/login.89cce56e.svg";